if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class extends HTMLElement {
      constructor() {
        super();
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartNotifcation = document.querySelector('cart-notification');
        this.cartDrawer = document.querySelector('cart-drawer');


        this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source !== 'product-form') return;
          this.handleErrorMessage(event.errors);
        });
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source !== 'product-form') return;
          this.onCartUpdate();
        });
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        

        const newLocal = document.querySelectorAll(`input[form="${this.form.getAttribute('id')}"]`);
        const formData = new FormData(this.form);
        newLocal.forEach(input => {
          if (input.parentElement.offsetWidth > 0) {
            formData.append(input.name, input.value)

          }
        });

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');


        publish(PUB_SUB_EVENTS.cartAdd, { formData: formData, id: 'product-form' });


      }

      onCartUpdate() {

        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          quickAddModal.hide(true);
        }

        this.submitButton.classList.remove('loading');
        if (this.cartNotifcation && this.cartNotifcation.classList.contains('is-empty')) this.cartNotifcation.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        this.submitButton.classList.remove('loading');
        this.querySelector('.loading__spinner').classList.add('hidden');
        
        if (errorMessage) {
          
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          
          if (this.hideErrors) return;
          
          this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
          
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
          
          this.errorMessage.textContent = errorMessage;
        }else{
          this.submitButton.removeAttribute('aria-disabled');
          
          this.submitButton.querySelector('span').classList.remove('hidden');
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (soldOutMessage) soldOutMessage.classList.add('hidden');;
          
          this.error = false;
          
          this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
          
          this.errorMessageWrapper.toggleAttribute('hidden', true);
          this.errorMessage.textContent = '';
        }
      }
    }
  );
}
